import { isObject, isUndefined } from 'lodash-es';

import aesCrypto from './crypto';
import { DEFAULT_EXPIRE_TIME, VARIABLE_GARD_TOKEN } from './config';
import type { LSK, SSK } from './config';
import { AESStorageProps } from './interface';
import { tryParseJson } from '../json';

type StorageKey = LSK | SSK;
class AESStorage {
	private storage: Storage;

	constructor(options: AESStorageProps.Options) {
		const { type } = options;

		this.storage = window[type];
	}

	/**
	 * 存储到 storage
	 * @param key
	 * @param value
	 * @param expire 过期时间 单位 s，不传则不会过期
	 */
	setItem(key: StorageKey, value: any, expire?: number) {
		const data = {
			value,
			time: Date.now(),
			expire: isUndefined(expire) ? undefined : Date.now() + 1000 * expire,
		};

		this.storage.setItem(key, aesCrypto.encrypt(JSON.stringify(data)));
	}

	getItem(key: StorageKey) {
		const initial = this.storage.getItem(key);
		if (!initial) return null;

		const result = tryParseJson(aesCrypto.decrypt(initial));
		const now = Date.now();

		if (result.expire && now >= result.expire) {
			//过期销毁
			this.removeItem(key);
			return null;
			//不过期回值
		} else {
			return result.value;
		}
	}

	/**
	 * 单一变量合集
	 * @description 一般用于设置简单的变量，比如点赞、转发等需要进行刷数处理，此时不希望一个变量
	 * 占用一个 key，就可以采取这个方法，参考 src/components/build/ConsFormHeader/index.tsx 分享按钮
	 * @param key
	 */
	setFlag(key: string, expire = DEFAULT_EXPIRE_TIME) {
		const data = {
			value: key,
			time: Date.now(),
			expire: Date.now() + 1000 * expire,
		};

		const initial = this.storage.getItem(VARIABLE_GARD_TOKEN);
		let dataSet = initial ? tryParseJson(aesCrypto.decrypt(initial)) : {};

		if (isObject(dataSet as Record<string, any>)) {
			dataSet[key] = data;
		} else {
			dataSet = { [key]: data };
		}

		this.storage.setItem(VARIABLE_GARD_TOKEN, aesCrypto.encrypt(JSON.stringify(dataSet)));
	}

	/**
	 * 获取 flag 是否存在
	 * @param key
	 * @returns
	 */
	getFlag(key: string) {
		const initial = this.storage.getItem(VARIABLE_GARD_TOKEN);
		if (!initial) return true;

		const dataSet = tryParseJson(aesCrypto.decrypt(initial));
		if (!dataSet) return true;

		const data = dataSet[key];
		if (!data) return true;

		return Date.now() >= data.expire;
	}

	removeItem(key: StorageKey) {
		this.storage.removeItem(key);
	}

	clear() {
		this.storage.clear();
	}
}

export const localAESStorage = new AESStorage({ type: AESStorageProps.Type.local });
export const sessionAESStorage = new AESStorage({ type: AESStorageProps.Type.session });
